import listQuery from 'graphql/queries/system/ServerPrinterListQuery.graphql';

const PrintServiceHelper = {
  type: 'PrintServiceHelper',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'printerName',
  },
};

export default PrintServiceHelper;
